import React, { useEffect, useState } from "react";

import {
  Box,
  Typography,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Grid,
  Select,
  MenuItem,
  FormControl,
  InputLabel
} from "@mui/material";

import api from "../../api/api";
import { format } from "date-fns";

export default function LeaveStatement() {

  const [leaves, setLeaves] = useState([]);
  const [balances, setBalances] = useState([]);

  // NEW: user filter
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");

  useEffect(() => {
    loadLeaves();
    loadBalances();
  }, []);

  // ====================================
  // LOAD LEAVE STATEMENT
  // ====================================

  const loadLeaves = async () => {

    try {

      const res = await api.get("/leaves");

      setLeaves(res.data);

      // NEW: extract unique users
      const uniqueUsers = [
        ...new Map(res.data.map(item => [item.user_id, item])).values()
      ];

      setUsers(uniqueUsers);

    } catch (error) {

      console.error("Error loading leaves", error);

    }
  };

  // ====================================
  // LOAD LEAVE BALANCES
  // ====================================

  const loadBalances = async () => {

    try {

      const res = await api.get("/leaves/balance");

      setBalances(res.data || []);

    } catch (error) {

      console.error("Error loading balances", error);

    }
  };

  // ====================================
  // FILTERED LEAVES
  // ====================================

  const filteredLeaves = selectedUser
    ? leaves.filter(l => l.user_id === selectedUser)
    : leaves;

  return (

    <Box p={4}>

      {/* ====================================
         LEAVE BALANCE DASHBOARD
      ==================================== */}

      <Typography variant="h5" mb={3}>
        Leave Balance
      </Typography>

      <Grid container spacing={2} mb={4}>

        {balances.map((b, index) => (

          <Grid item xs={12} md={3} key={index}>

            <Card>

              <CardContent>

                <Typography variant="h6">
                  {b.leave_type}
                </Typography>

                <Typography variant="body2">
                  Total: {b.total}
                </Typography>

                <Typography variant="body2">
                  Used: {b.used}
                </Typography>

                <Typography
                  variant="body2"
                  color="success.main"
                >
                  Remaining: {b.remaining}
                </Typography>

              </CardContent>

            </Card>

          </Grid>

        ))}

      </Grid>

      {/* ====================================
         USER FILTER
      ==================================== */}

      <Box mb={3} width={250}>

        <FormControl fullWidth>

          <InputLabel>User</InputLabel>

          <Select
            value={selectedUser}
            label="User"
            onChange={(e) => setSelectedUser(e.target.value)}
          >

            <MenuItem value="">
              All Users
            </MenuItem>

            {users.map(user => (
              <MenuItem
                key={user.user_id}
                value={user.user_id}
              >
                {user.user_name}
              </MenuItem>
            ))}

          </Select>

        </FormControl>

      </Box>

      {/* ====================================
         LEAVE STATEMENT TABLE
      ==================================== */}

      <Card>

        <CardContent>

          <Typography variant="h6" mb={2}>
            Leave Statement
          </Typography>

          <Table>

            <TableHead>

              <TableRow>

                <TableCell>User</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Start</TableCell>
                <TableCell>End</TableCell>
                <TableCell>Days</TableCell>
                <TableCell>Status</TableCell>

              </TableRow>

            </TableHead>

            <TableBody>

              {filteredLeaves.map((leave) => (

                <TableRow key={leave.id}>

                  <TableCell>
                    {leave.user_name}
                  </TableCell>

                  <TableCell>
                    {leave.leave_type}
                  </TableCell>

                  <TableCell>
                    {format(new Date(leave.start_date), "dd MMM yyyy")}
                  </TableCell>

                  <TableCell>
                    {format(new Date(leave.end_date), "dd MMM yyyy")}
                  </TableCell>

                  <TableCell>
                    {leave.total_days}
                  </TableCell>

                  <TableCell>
                    {leave.status}
                  </TableCell>

                </TableRow>

              ))}

            </TableBody>

          </Table>

        </CardContent>

      </Card>

    </Box>

  );
}